import "./scss/index.scss";
import AppRouter from "router";
import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "firebaseConfig";
import themeState from "states/themeEventTarget";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "queryClient";
import { ToastContainer } from "react-toastify";
import "./i18n";
import { SocketProvider } from "context/SocketProvider";

// Адрес WebSocket. В продакшене — от REACT_APP_API_ADDRESS (https → wss).
// Локально эта переменная не задана: HTTP идёт через proxy из package.json, а WebSocket
// через него не пробросить — подключаемся к локальному бэкенду напрямую (тот же порт, что в proxy)
const getSocketURL = () => {
  if (process.env.REACT_APP_WS_ADDRESS) return process.env.REACT_APP_WS_ADDRESS;
  if (process.env.REACT_APP_API_ADDRESS) return process.env.REACT_APP_API_ADDRESS.replace(/^http/, "ws") + "/ws";
  return `ws://${window.location.hostname}:8788/ws`;
};

const App = () => {
  const [mode, setMode] = useState<any>(themeState.theme);

  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode: mode,
      },
      components: {
        MuiCard: {
          styleOverrides: {
            root: {
              backgroundColor: "var(--background-color)",
            },
          },
        },
        MuiDialog: {
          styleOverrides: {
            root: {
              '& .MuiDialog-paper': {
                backgroundColor: "var(--background-color)",
              },
            },
          },
        },
      },
    });
  }, [mode]);

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("firebase user", user);
        if (user) {
          const idToken = await user.getIdToken();
        }
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  useEffect(() => {
    if (themeState.theme) {
      document.querySelector("html")?.setAttribute("data-theme", themeState.theme);
      document.querySelector("html")?.classList.remove("dark");
      document.querySelector("html")?.classList.remove("light");
      document.querySelector("html")?.classList.add(themeState.theme);
      setMode(themeState.theme);
    }

    themeState.addEventListener("theme", (e) => {
      if (e instanceof CustomEvent) {
        console.log("storage:", e.detail);
        document.querySelector("html")?.setAttribute("data-theme", e.detail);
        document.querySelector("html")?.classList.remove("dark");
        document.querySelector("html")?.classList.remove("light");
        document.querySelector("html")?.classList.add(e.detail);
        setMode(e.detail);
      }
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <SocketProvider url={getSocketURL()}>
          <AppRouter />
        </SocketProvider>
      </ThemeProvider>
      <ToastContainer />
    </QueryClientProvider>
  );
};

export default App;
